import { Api } from './index';

export const fetchScratchGame = (walletId) =>
  Api.post('/orders/scratch_off', walletId);

export const fetchScratchGameReward = (orderId) =>
  Api.post('/orders/scratch_off/reward', orderId);
